<template>
    <div>
        <button @click.prevent="toggleFavorite" class="favorite" :class="{'padding': padding}">
            <img :src="favoriteImg" alt="favorite" width="18" height="18">
        </button>
        <div class="floatLeft alert alert-danger errorbox mt10 alertFavorite" v-if="this.errorMessage">
            <ul class="m-0">
                <li class="fs13" v-text="this.errorMessage"></li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "FavoriteButton",
    props: {
        productId: {
            required: true,
            type: Number
        },
        padding: {
            required: false,
            type: Boolean,
            default: true,
        }
    },
    data () {
        return {
            errorMessage: null
        }
    },
    methods: {
        toggleFavorite() {
            this.$store.dispatch('toggleFavorite', {
                product_id: this.productId,
                destroy: this.isFavorite
            })
            .catch(error => {
                if (error.response.status === 401) {
                    this.errorMessage = error.response.data.message;
                }
            });

            if(!this.isFavorite){
                //trackFacebook('AddToWishlist');
            }
        }
    },
    computed: {
        isFavorite () {
            return this.$store.state.favorites.products.includes(this.productId);
        },
        favoriteImg () {
            if (this.isFavorite) {
                return '/images/icon-fav-checked.png';
            }
            return '/images/icon-fav.png';
        }
    },
    mounted () {
        this.$store.dispatch('loadFavorites');
    },
    watch: {
        errorMessage (val) {
            setTimeout(() => {
                this.errorMessage = null
            }, 5000);
        }
    }
}
</script>
